
import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Download } from 'lucide-react';
import * as XLSX from 'xlsx';

const FarmPriceUploadTemplate: React.FC = () => {
  const downloadTemplate = () => {
    const template = [
      {
        'Timestamp': '2024-01-01',
        'Product List': 'Example Product',
        'Region': 'Example Region',
        'Product Origin': 'Example Origin',
        'Farm Source Type': 'Example Source',
        'Supplier Name': 'Example Supplier',
        'Farm Price Per Kg': 100.00,
        'Sack_or_crate_cost_per_kg': 5.00,
        'Loading cost per Kg': 2.50,
        'Transportation_cost_per_Kg': 10.00,
        'Border cost per kg': 3.00,
        'Agent cost per Kg': 7.50,
        'Miscellaneous Costs': 2.00,
        'VAT': 15.00,
        'Product Remark': 'Example remark'
      }
    ];

    const ws = XLSX.utils.json_to_sheet(template);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Farm Prices Template');
    XLSX.writeFile(wb, 'farm_prices_template.xlsx');
  };

  return (
    <div className="flex items-center justify-between">
      <div>
        <Label>Excel File</Label>
        <p className="text-sm text-gray-600">
          Upload an Excel file with farm price data
        </p>
      </div>
      <Button
        variant="outline"
        onClick={downloadTemplate}
        className="flex items-center gap-2"
      >
        <Download className="h-4 w-4" />
        Download Template
      </Button>
    </div>
  );
};

export default FarmPriceUploadTemplate;
